export default "__VITE_ASSET__BKyz6Mpg__"